import React from 'react'
import { Typography } from '@jota-ds/lib-react'

export default function Five() {
    const canvasRef = React.useRef(null)
    var canvas
    var ctx
    var el

    React.useEffect(() => {
        el = document.getElementById('five')
        el.addEventListener('mousemove', handleMouseMove)
        canvas = canvasRef.current
        canvas.width = el.offsetWidth
        canvas.height = el.offsetHeight
        ctx = canvas.getContext('2d')
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, el.offsetWidth, el.offsetHeight)
    }, [])

    const circle = (x, y, radius) => {
        ctx.save();
        ctx.beginPath();
        ctx.arc(x, y, radius, 0, 3 * Math.PI);
        ctx.fillRect(0, 0, el.offsetWidth, el.offsetHeight)
        ctx.clip();
        ctx.clearRect(x - radius - 1, y - radius - 1,
            radius * 2 + 2, radius * 2 + 2);
        ctx.restore()
    }

    const handleMouseMove = event => {
        circle(event.clientX, event.clientY, 200)
    }

    return (
        <section id="five" className="five d-flex flex-column">
            <canvas className="d-none d-md-block" ref={canvasRef} id="canvas"></canvas>
            <div className="container d-flex align-items-center">
                <div className="pt-large pb-large">
                    <div className="row">
                        <div className="col-md-6 index-1">
                            <div className="mb-3 font-14">
                                <Typography component="paragraph">
                                    ENCONTRE OS BILHETES
                                </Typography>
                            </div>

                            <div className="title">
                                <Typography component="heading" size="large">
                                    Nunca fez um <br />
                                    curso da Meiuca?<br />
                                    Sem drama.
                                </Typography>
                            </div>
                            
                            <div className="mb-3 muted">
                                <Typography component="paragraph" size="large">
                                    Veja como encontrar os bilhetes <br />
                                    dourados espalhados por aí.<br />
                                </Typography>
                            </div>
                        </div>
                        <div className="col-md-6 d-none d-md-flex">
                            <img className="img-fluid" alt="" src="/assets/bilhete-dourado.png" />
                        </div>
                    </div>

                    <div className="row pt-large">
                        <div className="col-md-4"></div>
                        <div className="col-md-4 index-1 mb-5 mb-md-0">
                            <div className="img">
                                <img className="img-fluid" alt="" src="/assets/asset01.svg" />
                            </div>
                            <div className="subtitle">
                                <Typography component="heading" size="small">
                                    #BilheteDouradoMeiuca
                                </Typography>
                            </div>
                            <div className="mb-3 muted">
                                <Typography component="paragraph" size="small">
                                    Fique de olho no feed e busque <br />
                                    pela hashtag #BilheteDouradoMeiuca<br />
                                    pode ser que um deles apareça <br />
                                    na sua timeline, boa sorte!
                                </Typography>
                            </div>
                        </div>
                        <div className="col-md-4 index-1 mb-5 mb-md-0">
                            <div className="img">
                                <img className="img-fluid" alt="" src="/assets/asset02.svg" />
                            </div>
                            <div className="subtitle">
                                <Typography component="heading" size="small">
                                    Conhece alguém?
                                </Typography>
                            </div>
                            <div className="mb-3 muted">
                                <Typography component="paragraph" size="small">
                                    Toda pessoa ex aluna da Meiuca tem bilhetes <br />
                                    dourados para compartilhar, pode ser uma boa<br />
                                    a hora de colocar em prática o tão falado <br />
                                    networking (mas olha o bom senso, viu!).
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
